import { render, staticRenderFns } from "./modifyInfoDc.vue?vue&type=template&id=03480838&scoped=true"
import script from "./modifyInfoDc.vue?vue&type=script&lang=js"
export * from "./modifyInfoDc.vue?vue&type=script&lang=js"
import style0 from "./modifyInfoDc.vue?vue&type=style&index=0&id=03480838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03480838",
  null
  
)

export default component.exports